export default function useDarkMode() {
  const value = localStorage.getItem("darkmode");
  const isDarkMode = !!value && value !== "nodarkmode";
  return isDarkMode;
}
